import {Link} from "react-router-dom";

const GreyLink = ({ to, label }) => {
    return (
        <Link to={to} className={"block md:inline-block bg-backgroundGrey px-3 py-2 rounded-md text-center"}>{label}</Link>
    )
}

export default GreyLink